import { useBatchModalInfo } from '../@hooks'
import React from 'react'
import { AppReportSearchesModal } from '@components'
import { batchListData } from 'Pages/Batch/Page/@signals'
import { reportSearchesModalId } from '@signals'

export default function BatchDetailsDrawer() {
	const { isOpen } = useBatchModalInfo()

	if (!isOpen || !reportSearchesModalId.value) return null

	return <AppReportSearchesModal data={batchListData.value}/>
}